import { render } from "./SystemSettings.vue?vue&type=template&id=3593ed8e&ts=true"
import script from "./SystemSettings.ts?vue&type=script&lang=ts"
export * from "./SystemSettings.ts?vue&type=script&lang=ts"

import "./SystemSettings.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__